import { render, staticRenderFns } from "./groupsTag.vue?vue&type=template&id=582a4566&scoped=true"
import script from "./groupsTag.vue?vue&type=script&lang=js"
export * from "./groupsTag.vue?vue&type=script&lang=js"
import style0 from "./groupsTag.vue?vue&type=style&index=0&id=582a4566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582a4566",
  null
  
)

export default component.exports